import React from "react";
import { Button, Modal } from "../../../../../components";
import { DocumentPreview } from "../../../../../components/Onboarding/document/DocumentPreview";

const ViewModal = ({
  document,
  setCurrentDocument,
  onUpdateField,
  viewModalOpen,
  setViewModalOpen,
  setRejectApplicantModalOpen,
  setResendModalOpen,
  setVerifyModalOpen,
  loginUserUiid,
  actions = true,
}) => {
  // const previewUrl =
  //   "https://docs.google.com/gview?url=https://file-examples.com/wp-content/storage/2017/02/file-sample_100kB.docx&embedded=true";
  const card = {
    title: "(W2_H1B Onboarding) TekTree-Offer Letter - DOC47",
    initiatedDate: "08/15/2025",
    dueDate: "08/22/2025",
  };

  return (
    <Modal
      isOpen={viewModalOpen}
      showCloseButton={false}
      closeOnOutsideClick={true}
      width="max-w-6xl"
      onClose={() => {
        setCurrentDocument(null);
        setViewModalOpen(false);
      }}
      bodyGap={false}
    >
      <div className="flex flex-col gap-4 bg-[#F9F9F9] py-3 mb-5">
        <div className="rounded-lg px-6 pt-2">
          <div className=" flex items-center justify-between">
            {/* Left section */}
            <div className="flex gap-3">
              <Button
                icon={"picture_as_pdf"}
                variant="text"
                size="xl"
                color="black"
                className="!px-2"
              />

              <div className="hidden">
                <div className="font-medium">{card.title}</div>

                <div className="text-sm text-gray-600 mt-2">
                  <span className="text-neutrals-400">Initiated Date: </span>
                  <span className="font-semibold">{card.initiatedDate}</span>
                  {"  "}
                  <span className="text-primary-500">|</span>{" "}
                  <span className="text-neutrals-400">Due Date: </span>
                  <span className="font-semibold">{card.dueDate}</span>
                </div>
              </div>
            </div>

            {/* Status */}
            <div className="flex items-center justify-center gap-3">
              <Button
                icon={"arrow_left_alt"}
                title={"Back"}
                color="black"
                variant="outlined"
                onClick={() => {
                  setCurrentDocument(null);
                  setViewModalOpen(false);
                }}
                className="!py-1 !px-4"
              />
              {actions && 
                <>
                  <Button
                  title={"Applicant reject"}
                  color="danger"
                  variant="outlined"
                  className="!py-1 !px-4"
                  onClick={() => setRejectApplicantModalOpen(true)}
                />
                <Button
                  title={"Resend"}
                  color="info"
                  variant="outlined"
                  className="!py-1 !px-4"
                  onClick={() => setResendModalOpen(true)}
                />
                <Button
                  title={"Verify"}
                  color="success"
                  variant="outlined"
                  className="!py-1 !px-4"
                  onClick={() => setVerifyModalOpen(true)}
                  />
                </>
              }
            </div>
          </div>
        </div>
      </div>
      <DocumentPreview
        document={document}
        mode="approver"
        userId={loginUserUiid}
        userRole="approver"
        selectedApplicant={{}}
        onSelectApplicant={() => {}}
        applicants={[]}
        userFieldData={{}}
        initiatorData={{}}
        applicantData={{}}
        onUpdateField={onUpdateField}
        onSubmit={() => {}}
        // onDownload={() => handleDownloadDocument(currentDocument)}
        onDownload={() => {}}
        // onBack={() => {
        //   setView("table");
        //   setCurrentDocument(null);
        //   setCurrentUserId("");
        //   setCurrentUserRole("");
        //   setSelectedApplicant("");
        // }}
        onBack={() => {}}
      />
    </Modal>
  );
};

export default ViewModal;
